import { createSlice } from '@reduxjs/toolkit'
import { createApiAsyncThunk } from '@/services/apiService'
import { setTimeoutInDev } from '@/utils/environment'
import { addToPrestataireItems } from '../prestataires/prestatairesSlice'

const URL = 'historique'

// États initiaux
const initialState = {
  items: [],
  loadingStatus: {
    fetchList: false,
  },
  requestStatus: {
    success: false,
    error: null,
    errors: {}
  },
  filters: {
    page: 1,
    limit: 10
  },
  pagination: {
    totalCount: 0,
    totalPages: 0,
    currentPage: 1
  }
}

// Thunks
export const fetchHistorique = createApiAsyncThunk(
  'historique/fetchHistorique',
  async (params = {}, { api, dispatch, rejectWithValue }) => {
    try {
      await setTimeoutInDev()
      let url = URL
      if (params.bien_id) {
        url = `biens/${params.bien_id}/historique`
        delete params.bien_id
      }
      const response = await api
        .url(url)
        .query(params)
        .get()
      
      // Ajouter les prestataires au store des prestataires
      const prestataires = response.historique_items
        .map(item => item.prestataire)
        .filter(prestataire => prestataire !== null)
      dispatch(addToPrestataireItems(prestataires))
      
      return response
    } catch (error) {
      console.error(error)
      return rejectWithValue(error.message || 'Une erreur est survenue lors de la récupération de l\'historique')
    }
  }
)

// Slice
const historiqueSlice = createSlice({
  name: 'historique',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    resetRequestStatus: (state) => {
      state.requestStatus = initialState.requestStatus
    }
  },
  extraReducers: (builder) => {
    // fetchHistorique
    builder.addCase(fetchHistorique.pending, (state) => {
      state.loadingStatus.fetchList = true
      state.requestStatus.error = null
    })
    builder.addCase(fetchHistorique.fulfilled, (state, action) => {
      state.items = action.payload.historique_items
      state.pagination = {
        totalCount: action.payload.total_count,
        totalPages: action.payload.total_pages,
        currentPage: action.payload.current_page
      }
      state.loadingStatus.fetchList = false
      state.requestStatus.success = true
    })
    builder.addCase(fetchHistorique.rejected, (state, action) => {
      state.loadingStatus.fetchList = false
      state.requestStatus.error = action.payload
    })
  }
})

export const {
  setFilters,
  resetRequestStatus
} = historiqueSlice.actions

export default historiqueSlice.reducer